<template>
	<div class="tw-w-fit" :class="{ 'tw-pointer-events-none tw-opacity-50': disabled }">
		<AppMenu placement="bottom-start" @open="fetchOrderStatus">
			<template #trigger>
				<slot name="trigger" v-bind="{ orderStatus, changeStatusLoading }">
					<AppButton
						:label="orderStatus"
						endIcon="assets/v2/image/icons/arrow-down.svg"
						variant="gray"
						secondary
						:loading="changeStatusLoading"
					/>
				</slot>
			</template>
			<div class="tw-flex tw-flex-col tw-rounded-md tw-p-2">
				<div
					v-if="fetchStatusLoading"
					class="tw-flex tw-items-center tw-justify-center tw-pb-4"
					style="width: 70px"
				>
					<AppSpinner size="25px" />
				</div>
				<template v-else-if="orderStatusOptions.length">
					<div
						v-for="option in orderStatusOptions"
						:key="option.value"
						class="tw-cursor-pointer tw-rounded-md tw-p-2 hover:tw-bg-gray-100"
						@click="orderStatus = option.value"
					>
						{{ $t(`order-status-enum.${option.value}`) }}
					</div>
				</template>
				<div v-else>
					{{ $t('whatsapp.you-can-not-change-status') }}
				</div>
			</div>
		</AppMenu>
	</div>
</template>

<script setup>
import AppMenu from '@/v2/components/app-menu.vue';
import AppSpinner from '@/v2/components/spinner.vue';
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import Order from '../entities/order';
import { OrderStatus } from '../entities/enums';
import { useConfirm } from '../../../plugins/alert';

const props = defineProps({
	order: Order,
	disabled: Boolean,
});

const emit = defineEmits(['done']);

const { t } = useI18n();

const fetchStatusLoading = ref(false);
const orderStatusOptions = ref([]);
const changeStatusLoading = ref(false);

const fetchOrderStatus = async () => {
	fetchStatusLoading.value = true;
	const options = await props.order.getChangeStatusOptions();
	orderStatusOptions.value = options.data;
	fetchStatusLoading.value = false;
};

const changeStatus = async (status) => {
	changeStatusLoading.value = true;
	try {
		await props.order.updateOrderStatus(status);
		emit('done');
	} finally {
		changeStatusLoading.value = false;
	}
};

const changeStatusWithConfirm = useConfirm(changeStatus);

const orderStatus = computed({
	get() {
		if (!props.order) return;
		if (!props.order?.orderStatusValue) return '';
		return t(`order-status-enum.${props.order?.orderStatusValue}`);
	},
	set(opt) {
		if (opt === OrderStatus.Cancelled) {
			changeStatusWithConfirm(opt);
		} else {
			changeStatus(opt);
		}
	},
});
</script>

<style lang="scss" scoped></style>
